import { initCarousel } from './functions';

(function () {
  window.addEventListener('DOMContentLoaded', initializeRooms);
})();

function initializeRooms() {
  const rooms = document.querySelectorAll('.rooms');

  for (const room of rooms) {
    const glide = room.querySelector('.glide');
    initCarousel(glide, { perView: 3 });
  }
}
